import { FormControlLabel, FormGroup, TextField } from "@mui/material";
import MessageModal from "../../../../../customComponents/MessageModal";
import { Button } from "../../../../../stories/Button/Button";
import Input from "../../../../../stories/Input/Input";
import { Label } from "../../../../../stories/Label/Label";
import { Title } from "../../../../../stories/Title/Title";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import LoadingModal from "../../../../pages/LoadingModal";
import { useContext, useState } from "react";
import { WIDTH, emptyMessage } from "../../../../../utils/constants";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { AppContext } from "../../../../../context/context";
import { useNavigate, useParams } from "react-router-dom";

import { AntSwitch } from "../../../../../styles/Switch";
import Navbar from "../../../../common/layout/Navbar";
import {
  LicenseTypes,
  Operation,
  SeparatorTypes,
} from "../../../../../utils/Enum.types";
import {
  useBillbooks,
  GetStdVoucherBooksDetails,
  SwCompanySqlNumbers,
} from "../../../../../customHooks/useBillbooks";
import { Keys } from "../../../../../utils/Enum.keys";
import {
  handleZeros,
  isOptionEqualToValue,
  removeMoreSpace,
} from "../../../../../utils/UtilFunctions";
import { responseType } from "../../../../../utils/formTypes";
import { useMutation } from "@apollo/client";
import { UpdateSqlNumberConfig } from "./queries/mutation";
import {
  UpdateSqlNumberConfigResult,
  UpdateSqlNumberConfigVar,
} from "./queries/types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { GetCompanySqlNumberConfig } from "../../../../../queries/queries";

const BillBookConfig = () => {
  const navigate = useNavigate();
 
  const { state } = useContext(AppContext);
  const [voucherBookType, setVoucherBookType] = useState<responseType | null>(
    null
  );
  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState(emptyMessage);
  const { customer_id, company_id } = useUrlParams();

  const [voucherBookData, setVoucherBookData] = useState<SwCompanySqlNumbers>({
    id: 0,
    isPrefixed: false,
    prefillWidth: 0,
    prefillWithZero: false,
    separator: " ",
    suffixStr: "",
    currentNo: "",
    tableDesc: "",
    tableKey: "",
    startNo: "",
    prefixStr: "",

    customerID: 0,
    companyID: 0,
    finYrID: 0,
  });

  const separatorType = Object.values(SeparatorTypes).map((value) => {
    return value;
  });
  // const { configData: captationFee } = useSwConfigData(
  //   InstitutionAcctConfigurationTypes.HIDE_CAPITATION_FEE
  // );

  const { voucherBooks } = useBillbooks();

  const [updateSqlNumberConfig, { loading: updateLoading }] = useMutation<
    UpdateSqlNumberConfigResult,
    UpdateSqlNumberConfigVar
  >(UpdateSqlNumberConfig, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const HandleVoucherBook = (voucherBookId: number) => {
    const filteredVoucherDetails =
      voucherBooks?.data?.GetCompanySqlNumberConfig.find(
        ({ id }) => id === voucherBookId
      );

    if (filteredVoucherDetails) {
      setVoucherBookData(filteredVoucherDetails);
      handleZeros(filteredVoucherDetails.prefillWidth.toString());
    }
  };

  const HandleSubmit = async () => {
    if ( company_id && customer_id) {
      updateSqlNumberConfig({
        variables: {
          
          user_details,
          companyID: company_id ? company_id : 0,
          customerID: customer_id ? customer_id : 0,
          sqlNumberConfigId: voucherBookData.id,
          input: {
            isPrefixed: voucherBookData.isPrefixed,
            prefillWithZero: voucherBookData.prefillWithZero,
            startNo: voucherBookData.startNo,
            currentNo: voucherBookData.currentNo,
            prefillWidth: voucherBookData.prefillWidth,
            prefixStr: voucherBookData.prefixStr,
            separator: voucherBookData.separator,
            suffixStr: voucherBookData.suffixStr,
          },
        },
        refetchQueries: [
          {
            query: GetCompanySqlNumberConfig,
            variables: {
              
              customerId: customer_id,
              companyID: company_id,
              finYrId: state.ActiveFinYr?.id,
            },
          },
        ],
      }).then(({ data }) => {
        if (data) {
          setMessage({
            message: "Voucher Configuration Made Successfully",
            flag: true,
            operation: Operation.UPDATE,
          });
        }
      });
    }
  };
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVoucherBookData((prevValues) => ({
      ...prevValues,
      [e.target.name]: removeMoreSpace(e.target.value),
    }));
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE && message.flag) {
      setVoucherBookData({
        id: 0,
        isPrefixed: false,
        prefillWidth: 0,
        prefillWithZero: false,
        separator: " ",
        suffixStr: "",
        currentNo: "",
        tableDesc: "",
        tableKey: "",
        startNo: "",
        prefixStr: "",

        customerID: 0,
        companyID: 0,
        finYrID: 0,
      });
      setVoucherBookType(null);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.CONFIG} />
      <Title>Sql Number Configuration</Title>
      <div className="bill-book-config">
        <div className="bill-book-config__datablock row g-0">
          <div className="col bill-book-config__datablock--frame">
            <div className="label-grid">
              <Label>Name</Label>
              <FormAutocomplete
                className={formClasses.inputRoot}
                options={voucherBooks.responseType}
                openOnFocus
                freeSolo
                isOptionEqualToValue={(option) =>
                  isOptionEqualToValue(option as responseType, voucherBookType)
                }
                autoHighlight
                value={voucherBookType}
                onChange={(e, newValue) => {
                  if (newValue) {
                    setVoucherBookType(newValue as responseType);
                    HandleVoucherBook((newValue as responseType).value);
                  } else {
                    setVoucherBookType(null);
                  }
                }}
                forcePopupIcon
                renderInput={(params) => (
                  <TextField
                    autoFocus
                    {...params}
                    className={formClasses.formControlRoot}
                  />
                )}
              />
            </div>
            <div className="label-grid">
              <Label>Description</Label>
              <Input
                name="tableDesc"
                value={voucherBookData.tableDesc}
                onChange={(e) => handleValueChange(e)}
              />
            </div>
            <div className="bill-book-config__datablock--frame--grids">
              <Label>Voucher Start Number</Label>
              <Input value={voucherBookData.startNo} disabled />
              <Label> Current Voucher Number</Label>
              <Input
                name="currentNo"
                value={voucherBookData.currentNo}
                onChange={(e) => handleValueChange(e)}
              />
            </div>
            <div className="bill-book-config__datablock--form-labels--grids">
              <div>
                <FormGroup className="bill-book-config__datablock--form-labels">
                  <FormControlLabel
                    label="Is Prefixed"
                    control={
                      <AntSwitch
                        checked={voucherBookData?.isPrefixed ? true : false}
                        onClick={() => {
                          const newConfigValue = voucherBookData?.isPrefixed
                            ? false
                            : true;
                          voucherBookType &&
                            setVoucherBookData({
                              ...voucherBookData,
                              prefixStr: "",
                              separator: "",
                              suffixStr: "",
                              isPrefixed: newConfigValue,
                            });
                        }}
                      />
                    }
                    labelPlacement="start"
                  />
                </FormGroup>
              </div>
              {voucherBookData?.isPrefixed && (
                <>
                  <div className="bill-book-config__datablock--form-labels--grids--block">
                    <Label>Prefix</Label>
                    <Input
                      name="prefixStr"
                      value={voucherBookData.prefixStr}
                      onChange={(e) => handleValueChange(e)}
                    />
                  </div>
                  <div className="bill-book-config__datablock--form-labels--grids--block">
                    <Label>Suffix</Label>
                    <Input
                      name="suffixStr"
                      value={voucherBookData.suffixStr}
                      onChange={(e) => handleValueChange(e)}
                    />
                  </div>
                  <div className="bill-book-config__datablock--form-labels--grids--block">
                    <Label>Separator</Label>
                    <FormAutocomplete
                      className={formClasses.inputRoot}
                      options={separatorType}
                      openOnFocus
                      forcePopupIcon
                      value={voucherBookData.separator}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setVoucherBookData((prev) => ({
                            ...prev,
                            separator: newValue as SeparatorTypes,
                          }));
                        } else {
                          setVoucherBookData((prev) => ({
                            ...prev,
                            separator: "",
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === Keys.BACKSPACE) {
                          setVoucherBookData((prev) => ({
                            ...prev,
                            separator: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          className={formClasses.formControlRoot}
                        />
                      )}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="bill-book-config__datablock--form-labels--grids">
              <div>
                <FormGroup className="bill-book-config__datablock--form-labels">
                  <FormControlLabel
                    label="Prefill With Zero"
                    control={
                      <AntSwitch
                        checked={voucherBookData.prefillWithZero ? true : false}
                        onClick={() => {
                          const newConfigValue =
                            voucherBookData?.prefillWithZero ? false : true;
                          voucherBookType &&
                            setVoucherBookData({
                              ...voucherBookData,
                              prefillWidth: 0,
                              prefillWithZero: newConfigValue,
                            });
                        }}
                      />
                    }
                    labelPlacement="start"
                  />
                </FormGroup>
              </div>
              {voucherBookData.prefillWithZero && (
                <div>
                  <Label>Prefill Width</Label>
                  <FormAutocomplete
                    className={formClasses.inputRoot}
                    options={WIDTH}
                    openOnFocus
                    forcePopupIcon
                    value={voucherBookData.prefillWidth}
                    onChange={(e, newValue) => {
                      if (newValue) {
                        setVoucherBookData((prev) => ({
                          ...prev,
                          prefillWidth: newValue as number,
                        }));
                      } else {
                        setVoucherBookData((prev) => ({
                          ...prev,
                          prefillWidth: 0,
                        }));
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === Keys.BACKSPACE) {
                        setVoucherBookData((prev) => ({
                          ...prev,
                          prefillWidth: 0,
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        className={formClasses.formControlRoot}
                      />
                    )}
                  />
                </div>
              )}
            </div>

            <div className="label-grid">
              <div></div>
              <Input
                disabled
                value={
                  voucherBookData.prefixStr +
                  voucherBookData.separator +
                  handleZeros(voucherBookData.prefillWidth.toString()) +
                  voucherBookData.currentNo +
                  voucherBookData.separator +
                  voucherBookData.suffixStr
                }
                placeholder="Preview"
              />
            </div>
          </div>
          <div className="col bill-book-config__datablock--frame"></div>
        </div>
        <Button mode="save" onClick={HandleSubmit} />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
      <LoadingModal flag={false} />
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
    </>
  );
};

export default BillBookConfig;
